import React, { useState } from 'react';
import './CreateRoutineBottomSheet.css';
import BottomSheet from '../components/BottomSheet/BottomSheet';
import SearchCard from '../components/SearchCard/SearchCard';
import Banner from '../components/Banner/Banner';
import Button from '../components/Button/Button';
import Typography from '../components/Text/Typography';
import { RoutineType } from '../types/routine';

interface CreateRoutineBottomSheetProps {
  isOpen: boolean;
  onClose: () => void;
  onCreateRoutine: (routineType: RoutineType) => void;
}

const availableRoutineTypes: RoutineType[] = [
  {
    id: 'post-exercise',
    name: 'Post-Exercise',
    description: 'Skincare routine for after workouts and physical activity',
    icon: 'fitness'
  },
  {
    id: 'back-from-work',
    name: 'Back from Work',
    description: 'Evening routine to remove makeup and workday buildup',
    icon: 'work'
  },
  {
    id: 'beach-day',
    name: 'Beach Day',
    description: 'Special routine for sun protection and post-beach care',
    icon: 'sun'
  },
  {
    id: 'after-night-out',
    name: 'After a Night Out',
    description: 'Late night routine for makeup removal and recovery',
    icon: 'moon'
  }
];

const CreateRoutineBottomSheet: React.FC<CreateRoutineBottomSheetProps> = ({
  isOpen,
  onClose,
  onCreateRoutine
}) => {
  const [selectedRoutineType, setSelectedRoutineType] = useState<RoutineType | null>(null);

  const handleRoutineTypeClick = (routineType: RoutineType) => {
    setSelectedRoutineType(routineType);
  };

  const handleCreateRoutine = () => {
    if (selectedRoutineType) {
      onCreateRoutine(selectedRoutineType);
      setSelectedRoutineType(null);
      onClose();
    }
  };

  const handleClose = () => {
    setSelectedRoutineType(null);
    onClose();
  };

  return (
    <BottomSheet
      isOpen={isOpen}
      onClose={handleClose}
      title="Create New Routine"
    >
      <div className="create-routine-bottom-sheet-content">
        <Banner variant="info">
          Choose the type of routine you'd like to create. Each routine type is designed for specific situations and will help you maintain healthy skin in different contexts.
        </Banner>

        <div className="routine-types-grid">
          {availableRoutineTypes.map((routineType) => (
            <SearchCard
              key={routineType.id}
              product={{
                product_id: parseInt(routineType.id.replace(/-/g, '')),
                product_name: routineType.name,
                brand: 'Custom Routine',
                category: 'routine',
                image_url: undefined
              }}
              isSelected={selectedRoutineType?.id === routineType.id}
              onClick={() => handleRoutineTypeClick(routineType)}
            />
          ))}
        </div>

        <div className="bottom-sheet-actions">
          <Button
            variant="text"
            onClick={handleClose}
            className="cancel-button"
          >
            Cancel
          </Button>
          <Button
            variant="primary"
            onClick={handleCreateRoutine}
            disabled={!selectedRoutineType}
            className="create-button"
          >
            Create Routine
          </Button>
        </div>
      </div>
    </BottomSheet>
  );
};

export default CreateRoutineBottomSheet;
